<script>
export default {
    props: {
        classes: {
            type: String,
            default: 'text-green-500',
        },
        styles: {
            type: String,
            default: 'height:20px',
        },
    }
}
</script>

<template>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3.5" stroke="currentColor"
             :class="classes"
             :style="styles"
        >
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
        </svg>
</template>

>
